<template>
  <div v-if="show && activityInfo" class="box">
    <img :src="activityInfo.picurls" class="icon" @click="onGo" />
    <img
      src="../../../assets/img-v2/ic_close_activity.png"
      class="close"
      @click="onClose"
    />
  </div>
</template>

<script>
import { getReactivePicInfo } from "@/views/activity/api/activity-list";
import { ls } from "@/store/local-store";
import { isMiniprogram, getWebUrl } from "@/utils/index";
import { MpUtil } from "@/utils/MpUtil";

export default {
  name: "ActivityEntry",
  // 预留v-model实现
  model: {
    prop: "show",
    event: "close",
  },
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timer: null,
      activityInfo: null,
    };
  },
  computed: {
    cityId() {
      const { cityId } = this.$route.query || {};
      return cityId;
    },
  },
  mounted() {
    this.requestReactivePicInfo().then(this.autoRefresh);
  },
  activated() {
    this.requestReactivePicInfo().then(this.autoRefresh);
  },
  deactivated() {
    this.stopAutoRefresh();
  },
  destroyed() {
    this.stopAutoRefresh();
  },
  methods: {
    // 请求数据
    requestReactivePicInfo() {
      const cityId = this.cityId || ls.getItem("cityId");
      if (!cityId) return Promise.reject("cityId is null");

      return getReactivePicInfo({ cityId })
        .then((res) => {
          this.activityInfo = res && res.length ? res[0] : null;
        })
        .catch((err) => {
          this.activityInfo = null;
          console.error("requestReactivePicInfo err: ", err);
        });
    },
    // 自动刷新
    autoRefresh() {
      this.stopAutoRefresh();
      this.timer = setInterval(() => {
        this.requestReactivePicInfo();
      }, 10000);
    },
    // 停止自动刷新
    stopAutoRefresh() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    onGo() {
      if (isMiniprogram()) {
        const href = this.$router.resolve({
          name: "activityList",
        }).href;
        const h5Url = getWebUrl(href);
        const mpUrl = MpUtil.getUrl("web", { h5Url });
        MpUtil.navigateTo(mpUrl);
        return;
      }
      this.$router.push({
        name: "activityList",
      });
    },
    onClose() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  position: relative;
  width: 60px;
  height: 60px;
}
.icon {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.close {
  width: 16px;
  height: 16px;
  position: absolute;
  left: -8px;
  top: -8px;
}
</style>
